import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import {
  editPayrocMerchantAccount,
  EditPayrocMerchantAccountPayload,
} from 'api/admin/businesses/editPayrocMerchantAccount';

export const useEditPayrocMerchant = () => {
  return useMutation<unknown, AxiosError<{ error: string }>, EditPayrocMerchantAccountPayload>({
    mutationFn: async ({ merchantId, businessId, payrocMerchantAccountId }) => {
      return editPayrocMerchantAccount({
        merchantId,
        businessId,
        payrocMerchantAccountId,
      });
    },
    onSuccess: async () => {
      toaster('Payroc Merchant Account has been updated', {
        icon: '✅',
      });
    },
    onError: (error) => {
      Sentry.captureException(error);
      toaster(error?.response?.data?.error ?? 'An error occurred while updating merchant account', {
        icon: '❌',
      });
      return error;
    },
  });
};
